export const buttonTheme = {
    bySize: {
        md: {
            typographySize: 'sm',
            paddingH: (props) => props.theme.spacing.sm,
            height: '2.5rem',
            foundationSize: 'md',
        },
        sm: {
            typographySize: 'xs',
            paddingH: (props) => props.theme.spacing.xs,
            height: '1.75rem',
            foundationSize: 'sm',
        },
    },
    byShape: {
        normal: {
            radius: (props) => props.theme.radius.unstable_new.md,
        },
        pill: {
            radius: '100px', // to create a pill button, we need to provide radius which is always > button.height / 2
        },
    },
};
export const buttonNextSizeVariant = (size) => buttonTheme.bySize[size];
export const shapeVariant = (shape) => buttonTheme.byShape[shape];
